import { SelectOptionTypes } from "./types";

export const toSelectOption = (
  value?: number | null,
  label?: string | null,
): SelectOptionTypes | null => {
  if (value && label) {
    return { label, value: String(value) };
  }
  return null;
};
